<script lang="ts" setup>
import type { ClassValue } from 'clsx'

const props = defineProps<{
  class?: ClassValue
}>()
</script>

<template>
  <div
    :class="
      cn('rounded-lg border border-border bg-background p-6', props.class)
    "
  >
    <slot />
  </div>
</template>
